import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/activeType/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/activeType/insert',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: '/whg-park/api/activeType/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/activeType/update',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/activeType/get',
    method: 'post',
    data: data
  });
}
export function selectActivityManageFindList(data) {
  return request({
    url: '/whg-park/api/activeManage/selectActivityManageFindList',
    method: 'post',
    data: data
  });
}